import React from "react"
import { Block } from "baseui/block"
import { H2, H3, Paragraph2 } from "baseui/typography"
import { Button, SHAPE } from "baseui/button"
import WysiwygRenderer from "../components/WysiwygRenderer"
import moment from "moment"
import { DFPSlotsProvider } from "react-dfp"
import { navigate, useIntl } from "gatsby-plugin-intl"
import RelatedPosts from "../components/RelatedPosts"
import SEO from "../components/seo"
import AdSlotBlock from "../components/AdSlotBlock"
import { formatMessageFromData } from "../utils/intl"

const PostRendererTemplate = ({ pageContext }: any) => {
  const [showButton, setShowButton] = React.useState(0)
  const intl = useIntl()

  const handleScroll = () => {
    if (window.scrollY > 550) {
      setShowButton(1)
    } else {
      setShowButton(0)
    }
  }

  React.useEffect(() => {
    window.addEventListener("scroll", handleScroll)
  })

  const post = pageContext.content
  const { siteTitle, title, description, ogImage, keywords } = pageContext.seo
  return (
    <>
      <SEO
        title={title}
        description={description}
        ogImage={ogImage}
        siteTitle={siteTitle}
        keywords={keywords}
      />
      <DFPSlotsProvider dfpNetworkId="32036410">
        <>
          <AdSlotBlock type={"billboard"} />
          <Block
            maxWidth={"970px"}
            width={["100%", "95%", "95%", "100%"]}
            margin={"auto"}
            backgroundColor={"#232323"}
            marginTop={"20px"}
            marginBottom={"20px"}
            overrides={{
              Block: {
                style: ({ $theme }) => ({
                  [$theme.mediaQuery.small]: {
                    borderRadius: "0px",
                  },
                  [$theme.mediaQuery.medium]: {
                    borderRadius: "8px",
                  },
                }),
              },
            }}
          >
            <Block
              width={["90%", "90%", "80%"]}
              margin={"auto"}
              paddingTop={"20px"}
              paddingBottom={"40px"}
            >
              <Block
                paddingTop="20px"
                paddingBottom="20px"
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
                flexDirection={["column", "row", "row", "row"]}
                color={"white"}
              >
                <Block width={["100%", "74%", "74%", "74%"]}>
                  <H2 marginBottom={"10px"} color={"white"}>
                    {formatMessageFromData(post, "title")}
                  </H2>
                  <Paragraph2 color={"#979797"} marginTop={"0px"}>
                    Post : {moment(post.createdAt).format("D MMM YYYY hh:mma")}
                  </Paragraph2>
                </Block>
                <Button
                  overrides={{
                    BaseButton: {
                      style: ({ $theme }) => ({
                        fontFamily: "True Bold",
                        [$theme.mediaQuery.small]: {
                          width: "100%",
                        },
                        [$theme.mediaQuery.medium]: {
                          paddingLeft: "30px",
                          paddingRight: "30px",
                          width: "auto",
                        },
                      }),
                    },
                  }}
                  shape={SHAPE.pill}
                  onClick={() => navigate("/package/now")}
                >
                  {intl.formatMessage({ id: "RegisterNow" })}
                </Button>
              </Block>
              <WysiwygRenderer
                content={formatMessageFromData(post, "content")}
                className={"post-content"}
                withAds
              />
            </Block>
          </Block>
          {post.relates && post.relates.length > 0 && (
            <Block
              maxWidth={"970px"}
              width={["100%", "95%", "95%", "100%"]}
              margin={"auto"}
              marginTop={"20px"}
              marginBottom={"20px"}
            >
              <Block marginBottom={"40px"}>
                <H3 marginBottom={"10px"} color={"white"} marginTop="0px">
                  Related Content
                </H3>
                <RelatedPosts posts={post.relates} />
              </Block>
            </Block>
          )}
        </>
      </DFPSlotsProvider>
      <Button
        overrides={{
          BaseButton: {
            style: ({ $theme }) => ({
              fontFamily: "True Bold",
              position: "fixed",
              opacity: showButton,
              zIndex: showButton,
              transition: "all 0.4s ease-in-out",
              bottom: "16px",
              [$theme.mediaQuery.medium]: {
                width: "300px",
                left: "50%",
                marginLeft: "-150px",
              },
              [$theme.mediaQuery.small]: {
                width: "60%",
                left: "50%",
                marginLeft: "-30%",
                bottom: "90px",
              },
            }),
          },
        }}
        shape={SHAPE.pill}
        onClick={() => navigate("/package/now")}
      >
        {intl.formatMessage({ id: "RegisterNow" })}
      </Button>
    </>
  )
}

export default PostRendererTemplate
